import classNames from 'clsx';
import React from 'react';

import type { TennisMatch } from '@swf/generated/graphql/scoreboards/schemas';
import { Icon } from '@swf/sports/components';
import type { Participants } from '@swf/sports/types/event';

import Score, { Team } from '../Score/Score';

import styles from './TennisScoreboard.scss';

interface Props {
  participants: Participants;
  tennisMatch: TennisMatch;
  isValidInPlayStatus?: boolean;
}

const ServingIcon: React.FC<{ visible?: boolean; isValidInPlayStatus?: boolean }> = ({
  visible,
  isValidInPlayStatus
}) => (
  <div
    className={classNames(styles.icon, {
      [styles.hide]: !visible,
      [styles.inPlay]: isValidInPlayStatus
    })}
  >
    <Icon name="marker" size="x2" />
  </div>
);

const TennisScoreboard: React.FC<Props> = ({ participants, tennisMatch, isValidInPlayStatus }) => {
  const [teamA, teamB] = participants;
  const { teamAScore, teamBScore, currentSet } = tennisMatch;

  const isTeamAServing = currentSet?.currentGame?.teamServing === 'HOME';
  const isTeamBServing = currentSet?.currentGame?.teamServing === 'AWAY';
  const isTieBreak = currentSet?.currentGame?.type === 'TIEBREAK';

  return (
    <div data-testid="tennis-scoreboard">
      <div className={styles.team}>
        <Score isTransparentBg team={Team.HOME} score={teamAScore ? `${teamAScore}` : '0'} />
        <Score
          isTransparentBg
          team={Team.HOME}
          score={currentSet?.teamAScore ? `${currentSet.teamAScore}` : '0'}
        />
        <Score
          team={Team.HOME}
          score={currentSet?.currentGame?.teamAScore ? `${currentSet.currentGame.teamAScore}` : '0'}
          defaultNumberOfDigits={2}
          isValidInPlayStatus={isValidInPlayStatus}
          isTieBreak={isTieBreak}
        />
        <ServingIcon visible={isTeamAServing} isValidInPlayStatus={isValidInPlayStatus} />
        <span className={styles.name}>{teamA}</span>
      </div>
      <div className={styles.team}>
        <Score isTransparentBg team={Team.AWAY} score={teamBScore ? `${teamBScore}` : '0'} />
        <Score
          isTransparentBg
          team={Team.AWAY}
          score={currentSet?.teamBScore ? `${currentSet.teamBScore}` : '0'}
        />
        <Score
          team={Team.AWAY}
          score={currentSet?.currentGame?.teamBScore ? `${currentSet.currentGame.teamBScore}` : '0'}
          defaultNumberOfDigits={2}
          isValidInPlayStatus={isValidInPlayStatus}
          isTieBreak={isTieBreak}
        />
        <ServingIcon visible={isTeamBServing} isValidInPlayStatus={isValidInPlayStatus} />
        <span className={styles.name}>{teamB}</span>
      </div>
    </div>
  );
};

export default TennisScoreboard;
